<template>
	<input class="c_input" type="text" inputmode="decimal" :modelValue="modelValue" @input="onInput" />
</template>

<script setup lang="ts">
// util
import { numberonly } from '@/utils/function/format';

defineProps<{
	modelValue?: string;
}>();
const emit = defineEmits(['update:modelValue']);

const onInput = (event: Event) => {
	const target = event.target as HTMLInputElement;
	target.value = numberonly(target.value);
	emit('update:modelValue', numberonly(target.value));
};
</script>

<style scoped lang="scss"></style>
